<template> 
    <div class="card-archived" @click="clickChat(element)">

        <div class="row align-items-center">
            <div class="col-12" @click="clickChat(element)">
                <div class="row align-items-center">
                    <div class="col-2">
                        <div class="circle d-flex align-items-center justify-content-center">
                            <ficon :icon="['fa', 'archive']"></ficon>
                        </div>
                    </div>
                    <div class="col-10">
                        <div class="row d-flex align-items-center">
                            <div class="col-9 d-flex justify-content-start align-items-center">
                                <strong>{{element.name}}</strong>
                            </div>
                            <div class="col-3">
                                <div class="date-chat">
                                    {{this.date_orig}}
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex align-items-center">
                            <div class="col-7 d-flex justify-content-start last-message">
                                <i>{{element.last_message}} </i>
                            </div>
                            <div class="col-2">
                                
                            </div>
                            <div class="col-3 justify-content-center ">
                                {{element.staffname}}
                            </div>
                        </div>
                        <div class="row d-flex align-items-center" style="margin-bottom:10px">
                            <div class="col-9 d-flex justify-content-start" style="margin-top:5px;">
                                <sub> {{element.reparto}}</sub>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>

</template>

<script>

    import defapp from "../models/defapp.js"

    export default {
        name: 'CardArchived',
        data: function() {
            return  {
                date_orig: null
            };
        },
        props: ['element','showChat'],
        methods: {       
            clickChat: function(element)
            {
                this.showChat(element,defapp.TYPE_CHAT_ARCHIVED,5)
            }
        },
        computed: {  
            
        },
        mounted: function(){
            let date = new Date(this.element.date_orig * 1000)
            this.date_orig = date.toLocaleDateString()
        },
        updated: function() {
            let date = new Date(this.element.date_orig * 1000)
            this.date_orig = date.toLocaleDateString()
        },
        created: function()
        {
            let date = new Date(this.element.date_orig * 1000)
            this.date_orig = date.toLocaleDateString()
        }
    }
</script>